<template>
    <div
        v-if="content"
        class="c-why-quarkino-solutions"
    >
        <div class="c-why-quarkino-solutions__title">
            <h2 class="mb-3">
                {{ content.title }}
            </h2>
        </div>

        <div class="c-why-quarkino-solutions__content">
            <y-row class="justify-content-center">
                <y-col
                    v-for="(album, index) in content.albums"
                    :key="`solutions-${index}`"
                    sm="12"
                    md="6"
                    lg="6"
                >
                    <div class="c-why-quarkino-solutions__content__card">
                        <div class="c-why-quarkino-solutions__content__card__image">
                            <div class="img">
                                <img
                                    :src="album.link"
                                    :alt="album.title"
                                >
                            </div>
                            <div class="index-solution">
                                <span>
                                    {{ digits(((index + 1) < 10 ? 0 : '').toString() + (index + 1).toString(), $i18n.locale) }}
                                </span>
                            </div>
                        </div>
                        <div class="c-why-quarkino-solutions__content__card__title">
                            <div class="title">
                                <h3>
                                    {{ album.title }}
                                </h3>
                            </div>
                        </div>
                        <div class="c-why-quarkino-solutions__content__card__text mt-15">
                            <p
                                v-for="(text, textCount) in splitAndRemoveNewlines(album.description)"
                                :key="`solutions-${index}-${textCount}`"
                            >
                                {{ text }}
                            </p>
                        </div>
                    </div>
                </y-col>
            </y-row>
        </div>

        <div class="c-why-quarkino-solutions__slide-show-wrapper">
            <y-slideshow
                ref="Slideshow"
                height="auto"
                slides-per-view="1.2"
                pagination="1"
                autoplay
            >
                <y-slide
                    v-for="(album, index) in content.albums"
                    :key="`responsive-solutions-${index}`"
                >
                    <div class="pa-4">
                        <div class="c-why-quarkino-solutions__content__card">
                            <div class="c-why-quarkino-solutions__content__card__image">
                                <div class="img">
                                    <img
                                        :src="album.link"
                                        :alt="album.title"
                                    >
                                </div>
                                <div class="index-solution">
                                    <span>
                                        {{ digits(((index + 1) < 10 ? 0 : '').toString() + (index + 1).toString(), $i18n.locale) }}
                                    </span>
                                </div>
                            </div>
                            <div class="c-why-quarkino-solutions__content__card__title">
                                <div class="title">
                                    <h3>
                                        {{ album.title }}
                                    </h3>
                                </div>
                            </div>
                            <div class="c-why-quarkino-solutions__content__card__text">
                                <p
                                    v-for="(text, textCount) in splitAndRemoveNewlines(album.description)"
                                    :key="`solutions-${index}-${textCount}`"
                                >
                                    {{ text }}
                                </p>
                            </div>
                        </div>
                    </div>
                </y-slide>
            </y-slideshow>
        </div>
        <div
            v-if="content.custom"
            class="c-why-quarkino-solutions__action"
        >
            <y-button
                color="primary"
                :tag="isLink(content.custom['button-link']) ? 'a' : 'router-link'"
                :to="content.custom['button-link']"
                :href="content.custom['button-link']"
            >
                {{ content.custom['button-title'] }}
            </y-button>
        </div>
    </div>
</template>

<script>
    import { YSlide, YSlideshow } from '@groot-components/all';
    import { digits } from '@groot-nodes/helpers/number';
    import { isLink } from '@/helpers/helpers';

    export default {
        name      : 'Solutions',
        components: { YSlide, YSlideshow },

        /**
         * @inheritDoc
         */
        data() {
            return {
                content: null,
            };
        },
        
        /**
         * @inheritDoc
         */
        created() {
            this.fetch();
        },
        methods: {
            digits,
            isLink,

            /**
             * Split the string into an array using "\n" as the separator
             *
             * @param {string} text
             * @returns {*[]}
             */
            splitAndRemoveNewlines(text) {
                return text.split('\\n');
            },

            /**
             * Check the Promise.all Request Error
             *
             * @param {Array} req - Responses array
             * @param {index} index - number of response
             * @returns {boolean}
             */
            handleReq(req, index) {
                return req && req[index] && !req[index].isAxiosError;
            },

            /**
             * fetch hero data
             *
             * @returns {Promise}
             */
            fetch() {
                this.$wait.start('loading-advantage-section');
                const features = this.$services.Content.postSingle({
                    type     : 'landing-page',
                    slug     : 'why-quarkino-integrations',
                    including: ['title', 'custom', 'albums'],
                    locale   : this.$i18n.locale,
                }).catch((error) => {
                    this.handleError(error);
                });

                return Promise.all([features])
                    .then((responses) => {
                        if (this.handleReq(responses, 0)) {
                            this.content = responses[0].data.results;
                        }
                    })
                    .catch((error) => {
                        this.handleError(error);
                    })
                    .finally(() => {
                        this.$wait.end('loading-advantage-section');
                    });
            },
        },
    };
</script>

<style lang="scss" src="./index.scss"></style>
